/**
 * @generated SignedSource<<a86167cf33d9148d7192b88e655b4033>>
 * @relayHash 054ff1d044a88d72c8190c4e95486551
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03

import type { ConcreteRequest } from 'relay-runtime';
export type SignInvocationTokenForUIInput = {
  forgeContextToken: string;
  remoteKey: string;
};
export type useRemoteFetchClient_signInvocationTokenForUIMutation$variables = {
  input: SignInvocationTokenForUIInput;
};
export type useRemoteFetchClient_signInvocationTokenForUIMutation$data = {
  readonly signInvocationTokenForUI: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly forgeInvocationToken: {
      readonly jwt: string;
    } | null;
    readonly metadata: {
      readonly baseUrl: string;
    } | null;
    readonly success: boolean;
  } | null;
};
export type useRemoteFetchClient_signInvocationTokenForUIMutation = {
  response: useRemoteFetchClient_signInvocationTokenForUIMutation$data;
  variables: useRemoteFetchClient_signInvocationTokenForUIMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "concreteType": "ForgeInvocationToken",
  "kind": "LinkedField",
  "name": "forgeInvocationToken",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jwt"
    }
  ]
},
v7 = {
  "concreteType": "InvocationTokenForUIMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "baseUrl"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SignInvocationTokenForUIResponse",
        "kind": "LinkedField",
        "name": "signInvocationTokenForUI",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          },
          (v6/*: any*/),
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SignInvocationTokenForUIResponse",
        "kind": "LinkedField",
        "name": "signInvocationTokenForUI",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              },
              (v5/*: any*/)
            ]
          },
          (v6/*: any*/),
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03",
    "metadata": {},
    "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "fe7d32870ddf9b8f5524abb29f382040";

export default node;
